import React from 'react'
import { StripeOptions } from 'donate/types'

const context = React.createContext<StripeOptions>({})

export function useStripeContext() {
  return React.useContext(context)
}

export function useIsStripeLoaded() {
  const { stripe } = useStripeContext()
  return !!stripe
}

export const StripeContextProvider = context.Provider
